const url_stepper = new URL(window.location.href);
console.log("====> inside the stepper js content");
window.STONE_DATA = '';
window.SETTING_DATA = '';


document.addEventListener("DOMContentLoaded", function () {
  const SETTING_TO_STONE = "SETTING_TO_STONE";
  const STONE_TO_SETTING = "STONE_TO_SETTING";
  // Query Params
  let settingHandle = url_stepper.searchParams.get("setting-handle");
  let naturalStockNum = url_stepper.searchParams.get("natural_stock_num");
  let labgrownStockNum = url_stepper.searchParams.get("labgrown_stock_num");
  let settingVariant = url_stepper.searchParams.get("variant");
  let settingViewMode = url_stepper.searchParams.get("settingView");
  let SizeLater = url_stepper.searchParams.get("setting-ring-size") || '';
  

  // Steps components - Separate desktop and mobile selectors
  const desktopDiamondStep = document.querySelector(".stepper-wrapper:not(.stepper-wrapper-mobile) .diamond-step");
  const desktopSettingStep = document.querySelector(".stepper-wrapper:not(.stepper-wrapper-mobile) .setting-step");
  const desktopPreviewStep = document.querySelector(".stepper-wrapper:not(.stepper-wrapper-mobile) .preview-step");

  const mobileDiamondStep = document.querySelector(".stepper-wrapper-mobile .step:nth-child(2)");
  const mobileSettingStep = document.querySelector(".stepper-wrapper-mobile .step:nth-child(1)");
  const mobilePreviewStep = document.querySelector(".stepper-wrapper-mobile .step:nth-child(3)");

  const resetLinks = document.querySelectorAll(".reset-btn");

  // Use desktop elements by default, fallback to mobile if desktop not found
  const diamondStep = desktopDiamondStep || mobileDiamondStep;
  const settingStep = desktopSettingStep || mobileSettingStep;
  const previewStep = desktopPreviewStep || mobilePreviewStep;

  // Get step numbers for both desktop and mobile
  const desktopDiamondStepNumber = desktopDiamondStep ? desktopDiamondStep.querySelector(".step-number") : null;
  const desktopSettingStepNumber = desktopSettingStep ? desktopSettingStep.querySelector(".step-number") : null;
  const desktopPreviewStepNumber = desktopPreviewStep ? desktopPreviewStep.querySelector(".step-number") : null;

  const mobileDiamondStepNumber = mobileDiamondStep ? mobileDiamondStep.querySelector(".step-number") : null;
  const mobileSettingStepNumber = mobileSettingStep ? mobileSettingStep.querySelector(".step-number") : null;
  const mobilePreviewStepNumber = mobilePreviewStep ? mobilePreviewStep.querySelector(".step-number") : null;

  mobileSettingStep.href = "/collections/testing-collection";
  mobileDiamondStep.href = "/collections/stones";

  // Use desktop step numbers by default, fallback to mobile if desktop not found
  const diamondStepNumber = desktopDiamondStepNumber || mobileDiamondStepNumber;
  const settingStepNumber = desktopSettingStepNumber || mobileSettingStepNumber;
  const previewStepNumber = desktopPreviewStepNumber || mobilePreviewStepNumber;

  // Step links - Updated to work with both desktop and mobile
  const diamondChangeLink = document.querySelector("#diamond-change-link");
  const settingChangeLink = document.querySelector("#setting-change-link");

  // Check Pages
  const isCollectionPage = window.location.pathname.includes("/collections/");
  const isStoneCollection = window.location.pathname.includes(
    "/collections/stones"
  );
  const isProductPage = window.location.pathname.includes("/products/");
  const isStoneProduct = window.location.pathname.includes("/products/stone");

  // Main Logic
  if (diamondChangeLink) {
    diamondChangeLink.href = `/collections/stones`;
  }
  if (settingChangeLink) {
    settingChangeLink.href = `/collections/testing-collection`;
  }

  // Remove All Active State
  removeActiveState();
  
  // Collection pages
  if (isCollectionPage && !isProductPage) {
    
    if (isStoneCollection) {
      activateStep('stone');
      if(settingHandle) {
        setStepperOrder(SETTING_TO_STONE);
        getSettingDetailsFS();
      } else {
        setStepperOrder(STONE_TO_SETTING);
      }
    } else {
      activateStep('setting');
      if (settingChangeLink) {
        settingChangeLink.style.display = 'none';
      }
      if (naturalStockNum || labgrownStockNum) {
        setStepperOrder(STONE_TO_SETTING);
        fetchStoneDetailsFS();
      } else {
        setStepperOrder(SETTING_TO_STONE);
      }
    }
  }

  // Product pages
  if (isProductPage) {
    if(isStoneProduct) {
      activateStep('stone');
      if(settingHandle) {
        setStepperOrder(SETTING_TO_STONE);
        getSettingDetailsFS();
      } else {
        if (settingChangeLink) {
          settingChangeLink.style.display = 'block';
        }
        setStepperOrder(STONE_TO_SETTING);
      }
    } else {
      if(settingHandle && (naturalStockNum || labgrownStockNum) && !settingViewMode) {
        activateStep('preview');
        fetchStoneDetailsFS();
        getSettingDetailsFS();
      } else  {
        activateStep('setting');
        if(naturalStockNum || labgrownStockNum) {
          setStepperOrder(STONE_TO_SETTING);
          fetchStoneDetailsFS();
        } else {
          setStepperOrder(SETTING_TO_STONE);
        }
      }
    }
  }

  // Functions
  function removeActiveState() {
    // Remove active state from desktop version
    if (desktopDiamondStep) {
      desktopDiamondStep.classList.remove("active-step");
    }
    if (desktopSettingStep) {
      desktopSettingStep.classList.remove("active-step");
    }
    if (desktopPreviewStep) {
      desktopPreviewStep.classList.remove("last-step-active");
    }

    // Remove active state from mobile version
    if (mobileDiamondStep) {
      mobileDiamondStep.classList.remove("normal-active-mobile-step");
    }
    if (mobileSettingStep) {
      mobileSettingStep.classList.remove("normal-active-mobile-step");
    }
    if (mobilePreviewStep) {
      mobilePreviewStep.classList.remove("normal-active-mobile-step");
    }
  }

  function activateStep(step) {
    switch (step) {
      case "setting":
        if (desktopSettingStep) {
          desktopSettingStep.classList.remove("normal-step");
          desktopSettingStep.classList.add("active-step");
        }
        if (mobileSettingStep) {
          mobileSettingStep.classList.add("normal-active-mobile-step");
        }
        break;
      case "stone":
        if (desktopDiamondStep) {
          desktopDiamondStep.classList.add("active-step");
          desktopDiamondStep.classList.remove("normal-step");
        }
        if (mobileDiamondStep) {
          mobileDiamondStep.classList.add("normal-active-mobile-step");
        }
        break;
      case "preview":
        if (desktopPreviewStep) {
          desktopPreviewStep.classList.add("last-step-active");
          desktopPreviewStep.classList.remove("lst-step");
        }
        if (mobilePreviewStep) {
          mobilePreviewStep.classList.add("normal-active-mobile-step");
        }
        break;
    }
  }

  function setStepperOrder(order) {
    if (!settingStep || !diamondStep || !previewStep) return;

    switch(order) {
      case 'SETTING_TO_STONE':
        if (desktopSettingStep) desktopSettingStep.style.order = 1;
        if (desktopDiamondStep) desktopDiamondStep.style.order = 2;
        if (desktopPreviewStep) desktopPreviewStep.style.order = 3;
        if (mobileSettingStep) mobileSettingStep.style.order = 1;
        if (mobileDiamondStep) mobileDiamondStep.style.order = 2;
        if (mobilePreviewStep) mobilePreviewStep.style.order = 3;
        
        // Update desktop step numbers
        if (desktopSettingStepNumber) desktopSettingStepNumber.textContent = '1';
        if (desktopDiamondStepNumber) desktopDiamondStepNumber.textContent = '2';
        if (desktopPreviewStepNumber) desktopPreviewStepNumber.textContent = '3';
        
        // Update mobile step numbers
        if (mobileSettingStepNumber) mobileSettingStepNumber.textContent = '1';
        if (mobileDiamondStepNumber) mobileDiamondStepNumber.textContent = '2';
        if (mobilePreviewStepNumber) mobilePreviewStepNumber.textContent = '3';

        resetLinks.forEach((link)=> {
          link.href = "/collections/testing-collection";
        })
        break;
      case "STONE_TO_SETTING":
        if (desktopDiamondStep) desktopDiamondStep.style.order = 1;
        if (desktopSettingStep) desktopSettingStep.style.order = 2;
        if (desktopPreviewStep) desktopPreviewStep.style.order = 3;
        if (mobileDiamondStep) mobileDiamondStep.style.order = 1;
        if (mobileSettingStep) mobileSettingStep.style.order = 2;
        if (mobilePreviewStep) mobilePreviewStep.style.order = 3;
        
        // Update desktop step numbers
        if (desktopDiamondStepNumber) desktopDiamondStepNumber.textContent = '1';
        if (desktopSettingStepNumber) desktopSettingStepNumber.textContent = '2';
        if (desktopPreviewStepNumber) desktopPreviewStepNumber.textContent = '3';
        
        // Update mobile step numbers
        if (mobileDiamondStepNumber) mobileDiamondStepNumber.textContent = '1';
        if (mobileSettingStepNumber) mobileSettingStepNumber.textContent = '2';
        if (mobilePreviewStepNumber) mobilePreviewStepNumber.textContent = '3';

         resetLinks.forEach((link)=> {
          link.href = "/collections/stones";
        })
        break;
    }
  }

  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function updateSettingStepper(settingDetails) {
    const settingStepper = document.querySelector("#choose-setting-Price");
    const settingStepperLink = document.querySelector("#choose-setting-links");
    // let settingDetails = JSON.parse(localStorage.getItem("setting_details"));
    const diamondChangeLink = document.querySelector("#diamond-change-link");
    const settingChangeLink = document.querySelector("#setting-change-link");
    const settingViewLink = document.querySelector("[setting-view-link]");
    const mobileDiamondStep = document.querySelector("#mobile-diamond-step");
    

    settingStepper.innerHTML = settingDetails.title;
    settingStepper.style.display = "block";
    settingStepperLink.style.display = "block";
    settingChangeLink.textContent = "Cambiar";
    settingViewLink.style.display = 'inline-block';
    settingViewLink.href = `/collections/testing-collection/products/${settingHandle}?variant=${settingVariant}&setting-handle=${settingHandle}&setting-ring-size=${SizeLater}`;

    if(naturalStockNum) {
      settingViewLink.href += `&natural_stock_num=${naturalStockNum}&settingView=1`; 
    } else if (labgrownStockNum) {
      settingViewLink.href += `&labgrown_stock_num=${labgrownStockNum}&settingView=1`; 
    }

    diamondChangeLink.href += `?variant=${settingVariant}&setting-handle=${settingHandle}&setting-ring-size=${SizeLater}`;
    console.log('=======> inside diamond update,', diamondChangeLink.href);
    mobileDiamondStep.href = diamondChangeLink.href;

    desktopSettingStep.classList.add("normal-active-step");
    // if (mobileSettingStep) {
    //   mobileSettingStep.classList.add("normal-active-mobile-step");
    // }
  }

  function updateDiamondStepper(stoneDetails) {
    const diamondStepper = document.querySelector("#choose-diamond-Price");
    const diamondStepperLink = document.querySelector("#choose-diamond-links");
    const diamondViewLink = document.querySelector("[diamond-view-link]");
    const settingChangeLink = document.querySelector("#setting-change-link");
    const mobileSettingStep = document.querySelector("#mobile-setting-step");
    
    
    diamondStepper.innerHTML = `${stoneDetails.size}ct ${stoneDetails.shape} Diamond`;
    diamondStepper.style.display = "block";
    diamondStepperLink.style.display = "block";
    diamondChangeLink.textContent = "Cambiar";
    diamondViewLink.style.display = 'inline-block';
    diamondViewLink.href = "/products/stone?";
    settingChangeLink.href += `?filter.v.m.custom.shape=${stoneDetails.shape}`;
    
    
    
    if (naturalStockNum) {
      settingChangeLink.href += `&natural_stock_num=${stoneDetails.stock_num}&filter.v.m.custom.origin=Natural`;
      diamondViewLink.href += `natural_stock_num=${stoneDetails.stock_num}&`;
    } else {
      settingChangeLink.href += `&labgrown_stock_num=${stoneDetails.stock_num}&filter.v.m.custom.origin=Lab-Grown`;
      diamondViewLink.href += `labgrown_stock_num=${stoneDetails.stock_num}&`;
    }

    if(settingHandle) {
      diamondViewLink.href += `setting-handle=${settingHandle}&setting-ring-size=${SizeLater}`;    
    }
    console.log('=======> inside diamond update,', settingChangeLink.href);
    mobileSettingStep.href = settingChangeLink.href;
    desktopDiamondStep.classList.add("normal-active-step");
    // if (mobileDiamondStep) {
    //   mobileDiamondStep.classList.add("normal-active-mobile-step");
    // }
  }

  // Function to make API call
  async function fetchStoneDetailsFS() {
    const naturalStockNum = getQueryParam("natural_stock_num");
    const labgrownStockNum = getQueryParam("labgrown_stock_num");

    const formData = new FormData();
    formData.append("action", "get_stone_details");
    formData.append("shop", "macorina-joyeria-fina.myshopify.com");

    let origin = "";

    if (naturalStockNum) {
      formData.append("natural_stock_num", naturalStockNum);
      origin = "Natural";
    } else if (labgrownStockNum) {
      formData.append("labgrown_stock_num", labgrownStockNum);
      origin = "Lab Grown";
    }

    try {
      const response = await fetch(
        "https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      window.STONE_DATA = data.data;
      console.log('==========> stone data from stepper :::', window.STONE_DATA)
      window.dispatchEvent(new Event('STONE_DATA_READY'));
      updateDiamondStepper(data.data);
    } catch (error) {
      console.error("Error fetching stone details:", error);
      return null;
    }
  }

  async function getSettingDetailsFS() {
    const handle = getQueryParam("setting-handle");
    const formData = new FormData();

    formData.append("action", "fetch_product_options");
    formData.append("shop", "macorina-joyeria-fina.myshopify.com");
    formData.append("handle", handle);
    fetch("https://phpstack-998622-4818184.cloudwaysapps.com/frontend.php", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        let mainData = data.data.product_data;
        console.log(mainData);

        const settingDetails = {
          title: mainData.prod_title,
          price: mainData.price,
          image: mainData.images.split(",")[0],
        };
        window.SETTING_DATA = settingDetails;
        window.dispatchEvent(new Event('SETTING_DATA_READY'));
        updateSettingStepper(settingDetails);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});
